import {ALTODEFOULT, FONDODEFAULT, LARGODEFAULT} from "../Constantes";

export const obtenerDimenciones = (productos) => {

    let maxLargo = 0;
    let maxFondo = 0;
    let alturaTotal = 0;

    productos.forEach(producto => {
        const cantidad = producto.cantidad || 1;
        const largo = producto.largo || LARGODEFAULT;
        const fondo = producto.fondo || FONDODEFAULT;
        const alto = producto.alto || ALTODEFOULT;

        // Evaluamos el mayor largo y fondo de la base
        if (largo > maxLargo) maxLargo = largo;
        if (fondo > maxFondo) maxFondo = fondo;

        // Sumamos la altura total considerando la cantidad de unidades apiladas
        alturaTotal += (alto * cantidad);
    });

    return {
        largo: maxLargo.toFixed(0),
        fondo: maxFondo.toFixed(0),
        alto: alturaTotal.toFixed(0)
    };
}